// src/app/components/auth/components/EmailPasswordInput.tsx
import React from 'react';
import { FlexCol } from 'components/primitives/flex';
import Input from 'components/ui/Input/Input';
import ErrorMessage from 'components/ui/ErrorMessage/ErrorMessage';
import { useFormContext } from 'react-hook-form';
import { StyledPassword } from 'components/auth_flow/SharedComponents';

interface EmailPasswordInputProps {
  hidePassword?: boolean;
  onEmailBlur?: (value: string) => void;
  passwordInputRef?: React.Ref<HTMLInputElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export default function EmailPasswordInput({
  hidePassword,
  onEmailBlur,
  passwordInputRef,
  onKeyDown,
}: EmailPasswordInputProps) {
  const { watch, register, errors } = useFormContext();

  const gap = hidePassword ? '0' : '20px';

  return (
    <FlexCol gap={gap}>
      <FlexCol>
        <Input
          hasError={!!errors.email}
          hasValue={!!watch('email')}
          placeholder="Email"
          type="email"
          name="email"
          inputRef={register({
            required: 'Please enter email address',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i,
              message: 'Invalid email address',
            },
          })}
          onBlur={(e) => onEmailBlur && onEmailBlur(e.target.value)}
          data-testid="signup-email-input"
          onKeyDown={onKeyDown}
        />
        <ErrorMessage error={errors?.email} />
      </FlexCol>
      <FlexCol
        style={{
          height: hidePassword ? '0' : 'auto',
          overflow: hidePassword ? 'hidden' : 'visible',
          opacity: hidePassword ? 0 : 1,
          pointerEvents: hidePassword ? 'none' : 'auto',
          transition: 'opacity 200ms, height 200ms',
        }}
      >
        <StyledPassword name="password" register={register} ref={passwordInputRef} />
        <ErrorMessage error={errors?.password} />
      </FlexCol>
    </FlexCol>
  );
}
